import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/**
 * ===============================
 * ADMIN APP UPDATE SERVICE
 * ===============================
 */

/**
 * Get all app updates (admin view)
 */
export const fetchAllAppUpdates = async () => {
  try {

    const response = await api.get("/admin/app-updates");

    return {
      status: response.status,
      data: response.data,
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: [],
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to fetch app updates",
    };

  }
};

/**
 * Create new app update
 */
export const createAppUpdate = async (appUpdate) => {

  try {

    const response = await api.post(
      "/admin/app-updates",
      appUpdate
    );

    return {
      status: response.status,
      data: response.data,
      message: "App update created successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to create app update",
    };

  }

};

/**
 * Update app update
 */
export const updateAppUpdate = async (id, appUpdate) => {

  try {

    const response = await api.put(
      `/admin/app-updates/${id}`,
      appUpdate
    );

    return {
      status: response.status,
      data: response.data,
      message: "App update updated successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to update app update",
    };

  }

};

/**
 * Enable / Disable app update
 */
export const toggleAppUpdateStatus = async (id, enabled) => {

  try {

    const response = await api.patch(
      `/admin/app-updates/${id}/enable`,
      null,
      {
        params: { enabled },
      }
    );

    return {
      status: response.status,
      data: response.data,
      message: enabled
        ? "App update enabled"
        : "App update disabled",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      data: null,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to update status",
    };

  }

};

/**
 * Delete app update
 */
export const deleteAppUpdate = async (id) => {

  try {

    const response = await api.delete(
      `/admin/app-updates/${id}`
    );

    return {
      status: response.status,
      message: "App update deleted successfully",
    };

  } catch (err) {

    return {
      status: err.response?.status || 500,
      message:
        err.response?.data?.message ||
        err.message ||
        "Failed to delete app update",
    };

  }

};